type Errors = {
  invalidChar: string;
  invalidAreaCode: string;
  invalidNumber: string;
  invalidIntNumber: string;
};

type Parsed = {
  isValid: boolean;
  formattedValue: string;
  errorText: string;
  value?: string;
};

export function phoneValidator(input: string): Parsed {
  let isInternational = false;

  const parsed: Parsed = {
    isValid: false,
    formattedValue: "",
    value: input,
    errorText: "",
  };

  const errors: Errors = {
    invalidChar: "Phone number should be only numbers",
    invalidAreaCode: "Phone number has invalid area code",
    invalidNumber:
      'Invalid phone number. Start international numbers with a "+"',
    invalidIntNumber: "Phone number is not a valid international number",
  };

  const allowedPattern: RegExp = /[\W\d]/;
  const numberPattern: RegExp = /[0-9]/;
  const USPhonePattern: RegExp =
    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  let cleanedValue: string = "";

  // Check for invalid characters
  if (typeof input === "string" && input.length) {
    for (let i = 0; i < input.length; i += 1) {
      if (numberPattern.test(input[i])) {
        cleanedValue += input[i];
      } else if (!allowedPattern.test(input[i])) {
        parsed.errorText = errors.invalidChar;
        return parsed;
      }
    }
  }

  // Check if international number
  if (input[0] === "+" || input.substring(0, 2) === "00") {
    isInternational = true;
  }

  if (isInternational) {
    // strip any leading 00
    if (cleanedValue.substring(0, 2) === "00") {
      cleanedValue = cleanedValue.substring(2);
    }

    // Digits must be between 7 and 15
    if (cleanedValue.length < 7 || cleanedValue.length > 15) {
      parsed.errorText = errors.invalidIntNumber;
      return parsed;
    }

    parsed.errorText = errors.invalidIntNumber;
    return parsed;
  }

  // Otherwise, we assume it's a US Phone number

  // Strip leading 1
  if (cleanedValue[0] === "1") {
    cleanedValue = cleanedValue.substring(1);
  }

  // Length must be 10 digits
  if (cleanedValue.length !== 10) {
    parsed.errorText = errors.invalidNumber;
    return parsed;
  }

  // Area code can't start with a 0 or 1
  if (parseInt(cleanedValue[0], 10) <= 1) {
    parsed.errorText = errors.invalidAreaCode;
    return parsed;
  }

  // Change code can't start with a 0 or 1
  if (parseInt(cleanedValue[3], 10) <= 1) {
    parsed.errorText = errors.invalidNumber;
    return parsed;
  }

  // The number is the correct format
  parsed.isValid = true;
  parsed.formattedValue = cleanedValue.replace(USPhonePattern, "($1) $2-$3");

  return parsed;
}
